import {
  checkNameForAccountManagerFromServer,
  createAccountManagerFromServer,
  getAccountManagerDetailFromServer,
  getAccountManagerListFromServer,
  verifyPasswordWithAccountManagerFromServer,
} from "logic/services/Account-Manager/server";
import { actionController, convertToDecimal } from "../utils";
import {
  getCoinBalanceFromServer,
  getTokenBalanceFromServer,
} from "logic/services/Token-Kits/server";

export const accountManagerController = {
  //account 생성
  createAccountManager: (
    name: string,
    storageType: "KMS" | "MPC",
    password: string
  ) => {
    return actionController(async () => {
      try {
        const checkName = await checkNameForAccountManagerFromServer({
          query: {},
          data: {
            name,
          },
        });
        if (checkName.status === true) {
          throw new Error("Account_name_already_exists");
        }
        if (checkName.status === false) {
          const accountManager = await createAccountManagerFromServer({
            params: {},
            query: {},
            data: {
              name,
              storageType,
              usageType: "ADMIN", //ADMIN (관리자) , CUSTOMER (고객-고객)
              password,
            },
          });
          return accountManager;
        }
      } catch (e) {
        throw new Error("Failed_to_accountManager_create");
      }
    });
  },

  //account 조회
  getAccountManagerListWithBalance: (option?: {
    lastId?: string;
    offset?: number;
    limit?: number;
    order?: "ASC" | "DESC";
    kitId?: number; //추가
    microChainId?: number; //추가
    serviceIdentifier?: "TOKEN_KIT" | "NFT_KIT" | "MEMBERSHIP_KIT";
  }) => {
    return actionController(async () => {
      try {
        const accountManager = await getAccountManagerListFromServer({
          params: {},
          query: {
            usageTypes: ["ADMIN"],
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
          },
        });
        //주소만 뽑아서 할당
        const addressList = accountManager.data.map(
          (item: any) => item.address
        );

        //coin잔액 조회
        let coinBalance;
        if (option?.microChainId) {
          try {
            coinBalance = await getCoinBalanceFromServer({
              params: {},
              query: {
                microChainId: option?.microChainId,
                addresses: addressList,
              },
            });
          } catch (e) {
            coinBalance = addressList.map((address: string) => {
              return { address, balance: undefined };
            });
          }
        } else {
          coinBalance = addressList.map((address: string) => {
            return { address, balance: undefined };
          });
        }

        const parsedCoinBalance = coinBalance.map((data: any) => {
          if (!data.balance) {
            return { address: data.address, ethBalance: undefined };
          }
          // Wei를 Eth로 변환
          const ethBalance = convertToDecimal(data.balance, 18);
          return {
            address: data.address, // address를 사용해 매칭
            ethBalance,
          };
        });

        //token잔액 조회
        let tokenBalance;
        if (option?.kitId && option?.serviceIdentifier === "TOKEN_KIT") {
          //kitId가 존재할때만 토큰 조회
          try {
            tokenBalance = await getTokenBalanceFromServer({
              params: { kitId: option?.kitId },
              query: { addresses: addressList },
            });
          } catch (e) {
            tokenBalance = addressList.map((address: string) => {
              return { address, balance: undefined };
            });
          }
        } else {
          tokenBalance = addressList.map((address: string) => {
            return { address, balance: undefined };
          });
        }

        const parsedTokenBalance = tokenBalance.map((data: any) => {
          if (!data.balance) {
            return { address: data.address, ethBalance: undefined };
          }
          // Wei를 Eth로 변환
          const ethBalance = convertToDecimal(data.balance, 18);
          return {
            address: data.address, // address를 사용해 매칭
            ethBalance,
          };
        });

        const accountManagerList = {
          count: accountManager.total,
          rows: accountManager.data.map((item: any) => {
            // 해당 address에 매칭되는 coinBalance 객체를 찾기

            const coinData = parsedCoinBalance.find(
              (coin: any) => coin.address === item.address
            );

            const tokenData = parsedTokenBalance.find(
              (token: any) => token.address === item.address
            );

            return {
              ...item,
              coin_balance: coinData.ethBalance, // 매칭되는 coin_balance 추가
              token_balance: tokenData.ethBalance, // 매칭되는 token_balance 추가
            };
          }),
        };

        return accountManagerList;
      } catch (e) {
        throw new Error("Failed_to_accountManager_List");
      }
    });
  },

  getAccountManagerList: (option?: {
    lastId?: string;
    offset?: number;
    limit?: number;
    order?: "ASC" | "DESC";
  }) => {
    return actionController(async () => {
      try {
        const accountManager = await getAccountManagerListFromServer({
          params: {},
          query: {
            usageTypes: ["ADMIN"],
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
          },
        });

        const accountManagerList = {
          count: accountManager.total,
          rows: accountManager.data,
        };

        return accountManagerList;
      } catch (e) {
        throw new Error("Failed_to_accountManager_List");
      }
    });
  },
  //account 상세 조회
  getAccountManagerDetail: (accountId: string) => {
    return actionController(async () => {
      try {
        const accountManager = await getAccountManagerDetailFromServer({
          params: { accountId },
          query: {},
        });
        return accountManager;
      } catch (e) {
        throw new Error("Failed_to_accountManager_details");
      }
    });
  },

  //핀번호
  verifyPasswordWithAccountManager: (accountId: string, password: string) => {
    return actionController(async () => {
      try {
        const accountManager = await verifyPasswordWithAccountManagerFromServer(
          {
            params: { accountId },
            query: {},
            data: {
              password,
            },
          }
        );
        return accountManager;
      } catch (e) {
        throw new Error("verify_password_fail");
      }
    });
  },
};
